import { Component, Input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

@Component({
  selector: 'app-quantity-atom',
  templateUrl: './quantity-atom.component.html',
  standalone: false,
})
export class QuantityAtomComponent {
  @Input() quantity!: number;
  @Input() dark!: boolean;
  @Input() textColor?: IContentBuilderFieldColor;
  @Input() backgroundColor?: IContentBuilderFieldColor;
}
